import React from 'react';

type ClientStatus = 'active' | 'past';

interface ClientStatusFilterChipsProps {
  selectedStatuses: Set<ClientStatus>;
  onToggleStatus: (status: ClientStatus) => void;
  counts: Record<ClientStatus, number>;
}

const CLIENT_STATUSES: Array<{
  value: ClientStatus;
  label: string;
  unselectedStyle: string;
  selectedStyle: string;
}> = [
  {
    value: 'active',
    label: 'Active',
    unselectedStyle: 'bg-green-100 text-green-700 border border-green-200',
    selectedStyle: 'bg-green-200 text-green-800 border-2 border-green-400 shadow-sm',
  },
  {
    value: 'past',
    label: 'Inactive',
    unselectedStyle: 'bg-gray-100 text-gray-600 border border-gray-200',
    selectedStyle: 'bg-gray-200 text-gray-800 border-2 border-gray-400 shadow-sm',
  },
];

export function ClientStatusFilterChips({
  selectedStatuses,
  onToggleStatus,
  counts,
}: ClientStatusFilterChipsProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {CLIENT_STATUSES.map((status) => {
        const isSelected = selectedStatuses.has(status.value);
        const count = counts[status.value] ?? 0;

        return (
          <button
            key={status.value}
            type="button"
            onClick={() => onToggleStatus(status.value)}
            className={`
              px-2 py-1 rounded-md text-xs font-medium
              transition-all duration-150 hover:opacity-80 cursor-pointer
              ${isSelected ? status.selectedStyle : status.unselectedStyle}
            `}
            aria-pressed={isSelected}
            aria-label={`Filter by ${status.label} clients, ${count} clients`}
          >
            {status.label} <span className="ml-0.5 text-[10px]">({count})</span>
          </button>
        );
      })}
    </div>
  );
}
